import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { surveyIdAtom } from '../../atoms'

const document = graphql(`
  query SurveyFilterInformation_Main($surveyId: ID!) {
    survey(id: $surveyId, questionDisplayFilter: DETAIL_COUNT) {
      id
      questions {
        question_id
        question_text
        answer_options {
          option
          text
        }
        mt_questions
      }
      customerAttributeGroups {
        id
        name
        customerAttributes {
          id
          name
        }
      }
      brandGroups {
        id
        name
        mappedAt
        brands {
          id
          name
          number
        }
      }
    }
  }
`)

import { useMainQueryKey } from './useMainQueryKey'

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useMainQueryKey()
  const surveyId = useAtomValue(surveyIdAtom)

  return useQuery({
    enabled: exists(surveyId),
    queryFn: () => graphQLRequest({ document, variables: { surveyId } }),
    queryKey,
  })
}
